import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/api/client';

interface TopVendorsResponse {
  vendors: string[];
}

export const topVendorKeys = {
  all: ['topVendors'] as const,
  list: () => [...topVendorKeys.all, 'list'] as const,
};

export function useTopVendors() {
  return useQuery({
    queryKey: topVendorKeys.list(),
    queryFn: async () => {
      const response = await apiClient.get<TopVendorsResponse>('/expenses/top-vendors');
      return response.vendors;
    },
    staleTime: 5 * 60 * 1000, // 5 min — vendor rankings shift slowly
  });
}
